import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { useHistory } from 'react-router';

import { useToastError } from 'lib/hooks/useToastError';
import { successToast } from 'lib/components/toasts/success';
import { conversationsKeys } from './queryKeys';
import { EXPRESS_API } from 'configs/api/expressApi';

const markConversationAsRestored = async (
  conversationId: string
): Promise<any> => {
  return (await EXPRESS_API.patch(`conversations/${conversationId}/restore`))
    .data;
};

export const useRestoredConversationMutation = () => {
  const { showError } = useToastError();

  const queryClient = useQueryClient();
  const history = useHistory();

  return useMutation(markConversationAsRestored, {
    mutationKey: conversationsKeys.header_action(),
    onError: (err: AxiosError) => showError(err),
    onSuccess: () => {
      successToast({ title: 'Your message is restored successfully' });
      queryClient.invalidateQueries(conversationsKeys.lists());

      history.replace({
        pathname: `/conversations`,
      });
    },
  });
};
